import React from 'react';
import clsx from 'clsx';
import { Divider } from '@nextiva/next-ui-components';
import { Link } from 'react-router-dom';

import { SvgNewTab } from 'components/SvgIcon';

export const Section = ({ children, title, id, linkTo }) => {
  return (
    <div
      className="m-user-section"
      data-testid="PlatformAdminUI-UsersLink-Sections-UserSection"
    >
      <div>
        <div
          className="m-user-section__divider"
          data-testid="PlatformAdminUI-UsersLink-Sections-UserSectionDivider"
        >
          <Divider orientation="horizontal" variant="fullWidth" />
        </div>

        <div
          className="m-user-section__header"
          data-testid="PlatformAdminUI-UsersLink-Sections-UserSectionHeader"
        >
          <div
            className={clsx('Heading3', 'm-user-section__header__title')}
            data-testid="PlatformAdminUI-UsersLink-Sections-UserSectionTitle"
          >
            {title}
          </div>
          {linkTo && (
            <Link
              id={id}
              to={linkTo}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="PlatformAdminUI-UsersLink-Sections-Link"
            >
              <div className={clsx('Body', 'm-user-section__header__link')}>
                View {title}
                <SvgNewTab />
              </div>
            </Link>
          )}
        </div>
      </div>
      <div
        className="m-user-section__content"
        data-testid="PlatformAdminUI-UsersLink-Sections-UserSectionContent"
      >
        {children}
      </div>
    </div>
  );
};
